module.exports = {
  logger: () => {},
  progress: () => {},
};
